(() => {
  'use strict';
  if(window.IHCanopyCare)return;
  const configNode=document.getElementById('ih-care-config');
  if(!configNode)return;
  const config=JSON.parse(configNode.textContent);
  if(!config.enabled)return;
  const text=config.text;
  const baseFetch=window.fetch.bind(window);
  const money=cents=>new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'}).format(cents/100);
  const storageKey='_ih_care_v1';
  let cart,request,currentQuote,revision=0,timer,pending=false,navigating=false,selectionWrite=Promise.resolve();
  let selections={},cartGroups=new Map();
  const disabledControls=new Map();
  const careControls='[data-ih-care-unit],[data-ih-care-remove],[data-ih-care-coupon],[data-ih-care-coupon-apply],[data-ih-care-coupon-clear]';
  function lockCartControls(){
    if(!pending)return;
    for(const node of document.querySelectorAll('cart-items [data-cart-quantity],cart-items .btn-quantity,cart-items .cart-remove,cart-items #cart-note,cart-items #cart_conditions,#cart-checkout,#cart-sidebar-checkout')){
      if(!disabledControls.has(node))disabledControls.set(node,{disabled:node.disabled,aria:node.getAttribute('aria-disabled')});
      if('disabled' in node)node.disabled=true;
      node.setAttribute('aria-disabled','true');
    }
    for(const node of document.querySelectorAll(careControls))node.disabled=true;
  }
  function setBusy(value){
    pending=value;
    for(const root of roots())root.setAttribute('aria-busy',String(value));
    const widget=document.querySelector('cart-items');
    if(widget){
      let status=widget.querySelector('[data-ih-care-cart-status]');
      if(!status){status=document.createElement('p');status.dataset.ihCareCartStatus='';status.className='ih-care-cart-status';status.setAttribute('role','status');widget.querySelector('#main-cart-items')?.before(status);}
      status.textContent=value?text.updatingCart:'';status.hidden=!value;
    }
    if(value){clearTimeout(timer);++revision;lockCartControls();}
    else{
      for(const [node,previous]of disabledControls){
        if('disabled' in node)node.disabled=previous.disabled;
        if(previous.aria===null)node.removeAttribute('aria-disabled');else node.setAttribute('aria-disabled',previous.aria);
      }
      disabledControls.clear();
      for(const node of document.querySelectorAll(careControls))node.disabled=false;
      for(const node of document.querySelectorAll('#cart-checkout,#cart-sidebar-checkout'))node.removeAttribute('aria-busy');
    }
  }
  async function settleNote(){
    const widget=document.querySelector('cart-items');
    if(widget){clearTimeout(widget.cartNoteTimer);await widget.cartNoteSave?.catch(()=>{});}
    return widget?.querySelector('#cart-note')?.value;
  }
  async function flushNote(){
    const note=await settleNote();
    if(note===undefined)return;
    if(document.querySelector('cart-items')?.savedCartNote===note)return;
    const response=await baseFetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{
      method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note})});
    if(!response.ok||(await response.json()).note!==note)throw new Error(text.saveError);
    const widget=document.querySelector('cart-items');if(widget){widget.savedCartNote=note;widget.setCartNoteStatus?.('saved');}
  }
  async function renderCart(nextCart){
    const widget=document.querySelector('cart-items');
    const target=widget?.querySelector('#main-cart-items');
    const section=widget?.dataset.sectionId||widget?.dataset.section;
    if(!target||!section)return;
    let html=nextCart.sections?.[section];
    // A section may fail after the cart write succeeds. Retry only the read.
    if(!html){
      const response=await baseFetch((window.Shopify?.routes?.root||'/')+'cart?sections='+encodeURIComponent(section));
      if(response.ok)html=(await response.json())[section];
    }
    if(!html)throw new Error(text.unavailable);
    const parsed=new DOMParser().parseFromString(html,'text/html');
    const content=parsed.querySelector('#main-cart-items');
    if(!content)throw new Error(text.unavailable);
    const active=document.activeElement;
    const activeLine=active?.closest('cart-update-quantity')?.querySelector('[data-cart-quantity]')?.dataset.line;
    const focusSelector=['[data-plus-quantity-cart]','[data-minus-quantity-cart]','[data-cart-quantity]'].find(selector=>active?.matches(selector));
    if(nextCart.item_count){
      const rows=target.querySelector('[data-cart-content] .cart');
      const nextRows=content.querySelector('[data-cart-content] .cart');
      if(!rows||!nextRows)throw new Error(text.unavailable);
      rows.replaceChildren(...nextRows.childNodes);
      for(const selector of ['.cart-total-subtotal','.cart-total-grandtotal','.cart-total-savings','.haloCalculatorShipping']){
        const old=target.querySelector(selector),replacement=content.querySelector(selector);
        if(old&&replacement)old.replaceWith(replacement);
      }
      if(activeLine&&focusSelector){
        const input=[...rows.querySelectorAll('[data-cart-quantity]')].find(node=>node.dataset.line===activeLine&&node.getClientRects().length);
        input?.closest('cart-update-quantity')?.querySelector(focusSelector)?.focus({preventScroll:true});
      }
    }else target.replaceChildren(...content.childNodes);
    for(const node of document.querySelectorAll('[data-cart-count]'))node.textContent=nextCart.item_count;
    const label=nextCart.item_count===1?window.cartStrings?.countOne:window.cartStrings?.countOther?.replace('0',String(nextCart.item_count));
    if(label)for(const node of document.querySelectorAll('.cart-count-bubble .visually-hidden'))node.textContent=label;
    if(widget){widget.savedCartNote=nextCart.note||'';widget.setCartNoteStatus?.('saved');}
    lockCartControls();
    document.dispatchEvent(new CustomEvent('cart-update',{detail:nextCart}));
  }
  async function mutateCart(command){
    if(pending)return;
    setBusy(true);
    try{
      const note=await settleNote();
      await selectionWrite;
      if(!await refresh({calculate:false}))throw new Error(text.saveError);
      const updates={};let nextSelections={...selections};
      if(command.unitKey){
        const split=command.unitKey.lastIndexOf('/');
        const parent=command.unitKey.slice(0,split),unit=Number(command.unitKey.slice(split+1));
        const group=cartGroups.get(parent),item=group?.nativeItems.at(-1);
        if(!item||!Number.isInteger(unit)||unit<1||unit>group.quantity)throw new Error(text.saveError);
        for(const key of Object.keys(nextSelections))if(key.startsWith(parent+'/'))delete nextSelections[key];
        let nextUnit=0;
        for(let index=1;index<=group.quantity;index++)if(index!==unit)nextSelections[`${parent}/${++nextUnit}`]=selections[`${parent}/${index}`]||'none';
        updates[item.key]=item.quantity-1;
      }else if(command.lineKey){
        const item=cart.items.find(item=>item.key===command.lineKey);
        if(!item||!Number.isSafeInteger(command.quantity)||command.quantity<0)throw new Error(text.saveError);
        updates[item.key]=command.quantity;
      }
      const widget=document.querySelector('cart-items');
      const section=widget?.dataset.sectionId||widget?.dataset.section;
      const sectionRequest=section?{sections:[section],sections_url:(window.Shopify?.routes?.root||'/')+'cart'}:{};
      // change.js enforces inventory on quantity increases; update.js keeps a
      // per-canopy removal and the corresponding selection remap atomic.
      if(command.lineKey)await flushNote();
      const body=command.lineKey?{id:command.lineKey,quantity:command.quantity,...sectionRequest}:{
          updates,attributes:{[storageKey]:JSON.stringify(nextSelections)},...(note===undefined?{}:{note}),
          ...(command.discount===undefined?{}:{discount:command.discount}),...sectionRequest};
      const response=await baseFetch((window.Shopify?.routes?.root||'/')+(command.lineKey?'cart/change.js':'cart/update.js'),{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      const updated=await response.json();
      if(!response.ok)throw new Error(updated.description||text.saveError);
      selections=nextSelections;
      await renderCart(updated);
      if(!await refresh())throw new Error(text.unavailable);
    }catch(error){
      for(const input of document.querySelectorAll('cart-items [data-cart-quantity]'))input.value=input.defaultValue;
      await refresh();setError(error.message||text.saveError);
    }finally{setBusy(false);}
  }
  const api=async(path,body)=>{
    if(!config.endpoint)throw new Error(text.unavailable);
    const response=await baseFetch(config.endpoint+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    const data=await response.json();
    if(!response.ok)throw new Error(data.error||text.unavailable);
    return data;
  };
  const identity=async item=>{
    const properties=Object.entries(item.properties||{}).filter(([key])=>!key.startsWith('_ih_care'))
      .sort(([a],[b])=>a.localeCompare(b));
    const bytes=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(JSON.stringify([item.id,properties,item.selling_plan_allocation?.selling_plan?.id||null])));
    return Array.from(new Uint8Array(bytes)).map(v=>v.toString(16).padStart(2,'0')).join('');
  };
  const readCart=async()=>{
    const response=await baseFetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{'Accept':'application/json'}});
    if(!response.ok)throw new Error(text.unavailable);
    return response.json();
  };
  const normalized=async value=>{
    const groups=new Map();
    for(const item of value.items){
      const key=await identity(item);
      const group=groups.get(key);
      if(group){group.quantity+=item.quantity;group.nativeItems.push(item);}
      else groups.set(key,{id:item.id,key,quantity:item.quantity,properties:item.properties||{},
        sellingPlan:item.selling_plan_allocation?.selling_plan?.id||null,nativeItems:[item]});
    }
    return {groups,payload:{currency:value.currency,items:[...groups.values()].map(({nativeItems,...item})=>item),
      selections:{...selections},note:(value.note||'').slice(0,5000),
      discountCodes:(value.discount_codes||[]).filter(code=>code.applicable!==false).map(code=>code.code).slice(0,5)}};
  };
  function roots(){return [...document.querySelectorAll('[data-ih-care-root]')];}
  function setError(message){for(const root of roots()){
    const box=root.querySelector('[data-ih-care-error]');if(box){box.textContent=message;box.hidden=!message;}
  }
    const widget=document.querySelector('cart-items');
    if(widget){
      let box=widget.querySelector('[data-ih-care-cart-error]');
      if(!box){box=document.createElement('p');box.dataset.ihCareCartError='';box.className='ih-care-error';box.setAttribute('role','alert');widget.querySelector('#main-cart-items')?.before(box);}
      box.textContent=message;box.hidden=!message||roots().some(root=>!root.hidden);
    }
  }
  function ensureRoot(root){
    if(root.querySelector('[data-ih-care-units]'))return;
    root.append(document.getElementById('ih-care-template').content.cloneNode(true));
  }
  function render(quote){
    for(const root of roots()){
      root.hidden=!quote?.plan?.canopyCount;
      if(root.hidden)continue;
      ensureRoot(root);
      const reward=root.querySelector('[data-ih-care-reward]');
      reward.textContent=quote.plan.freeBasic?text.freeReward:quote.plan.halfPrice?text.halfReward:text.normalReward;
      const focused=document.activeElement?.dataset?.ihCareUnit;
      const units=root.querySelector('[data-ih-care-units]');units.replaceChildren();
      for(const unit of quote.plan.units){
        const item=cartGroups.get(unit.parentKey)?.nativeItems[0];
        const row=document.createElement('div');row.className='ih-care-unit';
        const name=document.createElement('div');const title=document.createElement('strong');
        title.textContent=item?.product_title||item?.title||text.canopy;
        const detail=document.createElement('small');detail.textContent=[item?.variant_title,text.unit.replace('__UNIT__',unit.unit)].filter(Boolean).join(' · ');
        name.append(title,detail);row.append(name);
        const select=document.createElement('select');select.dataset.ihCareUnit=unit.unitKey;select.disabled=pending;
        select.setAttribute('aria-label',`${text.choose} ${title.textContent} ${detail.textContent}`);
        for(const plan of ['none','basic','standard','premium']){
          const option=document.createElement('option');option.value=plan;
          const list={none:0,basic:19900,standard:59900,premium:79900}[plan];
          const price=plan==='basic'&&quote.plan.freeBasic?0:quote.plan.halfPrice?list/2:list;
          option.textContent=plan==='none'?(quote.plan.freeBasic?text.autoGift:text.none):
            `${text[plan]} · ${price===0?text.free:money(price)}`;
          option.selected=plan===unit.requested;select.append(option);
        }
        row.append(select);const price=document.createElement('span');price.className='ih-care-unit-price';
        price.textContent=unit.effective==='none'?'—':unit.expectedCents===0?text.free:money(unit.expectedCents);
        row.append(price);units.append(row);
        const remove=document.createElement('button');remove.type='button';remove.className='ih-care-remove';
        remove.dataset.ihCareRemove=unit.unitKey;remove.textContent=text.remove;remove.disabled=pending;
        remove.setAttribute('aria-label',`${text.remove} ${title.textContent} ${detail.textContent}`);row.append(remove);
        if(focused===unit.unitKey)select.focus({preventScroll:true});
      }
      for(const node of root.querySelectorAll('[data-ih-care-plan-price]')){
        const plan=node.dataset.ihCarePlanPrice;
        const list={basic:19900,standard:59900,premium:79900}[plan];
        const price=plan==='basic'&&quote.plan.freeBasic?0:quote.plan.halfPrice?list/2:list;
        node.textContent=price===0?text.free:money(price);
      }
      root.querySelector('[data-ih-care-total]').textContent=money(quote.plan.expectedCareCents);
      root.querySelector('[data-ih-care-subtotal]').textContent=money(quote.subtotalCents);
      const coupon=root.querySelector('[data-ih-care-coupon]');
      if(coupon&&document.activeElement!==coupon)coupon.value=(cart.discount_codes||[]).map(code=>code.code).join(',');
      const couponStatus=root.querySelector('[data-ih-care-coupon-status]');
      if(couponStatus){
        const codes=cart.discount_codes||[];
        couponStatus.textContent=codes.some(code=>code.applicable===false)?text.couponInvalid:
          codes.length?text.couponApplied.replace('__CODES__',codes.map(code=>code.code).join(', ')):'';
      }
      setError('');
    }
  }
  async function persist(){
    const value=JSON.stringify(selections);
    selectionWrite=selectionWrite.catch(()=>{}).then(async()=>{
      const response=await baseFetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[storageKey]:value}})});
      if(!response.ok)throw new Error(text.saveError);
    });
    return selectionWrite;
  }
  async function refresh({loadSelections=true,calculate=true}={}){
    const thisRevision=++revision;
    currentQuote=null;
    try{
      await selectionWrite;
      const nextCart=await readCart();
      if(thisRevision!==revision)return false;
      if(loadSelections){
        try{
          const saved=JSON.parse(nextCart.attributes?.[storageKey]||'{}');
          selections=Object.fromEntries(Object.entries(saved||{}).filter(([,value])=>['none','basic','standard','premium'].includes(value)));
        }catch{selections={};}
      }
      const {payload:nextRequest,groups}=await normalized(nextCart);
      if(thisRevision!==revision)return false;
      if(!nextCart.items.some(item=>config.canopyProductIds.includes(String(item.product_id)))){
        if(Object.keys(selections).length){selections={};await persist();}
        if(thisRevision!==revision)return false;
        cart=nextCart;cartGroups=groups;request=nextRequest;currentQuote=null;for(const root of roots())root.hidden=true;return true;
      }
      const validKeys=new Set(nextRequest.items.flatMap(item=>Array.from({length:item.quantity},(_,i)=>`${item.key}/${i+1}`)));
      let pruned=false;
      for(const key of Object.keys(selections))if(!validKeys.has(key)){delete selections[key];pruned=true;}
      nextRequest.selections={...selections};
      if(pruned)await persist();
      if(!calculate){cart=nextCart;cartGroups=groups;request=nextRequest;currentQuote=null;return true;}
      const quote=await api('/quote',{cart:nextRequest});
      if(thisRevision!==revision)return false;
      cart=nextCart;cartGroups=groups;request=nextRequest;currentQuote=quote;render(quote);
      return true;
    }catch(error){if(thisRevision===revision){for(const root of roots()){root.hidden=false;ensureRoot(root);}setError(error.message||text.unavailable);}return false;}
  }
  function schedule(){if(pending||!roots().length)return;clearTimeout(timer);timer=setTimeout(()=>{void refresh();},180);}
  async function checkout(button,sidebar){
    if(pending||button.disabled)return;
    setBusy(true);button.setAttribute('aria-busy','true');
    try{
      await flushNote();
      await selectionWrite;
      if(sidebar){
        const latest=await readCart();
        const hasCanopy=latest.items.some(item=>config.canopyProductIds.includes(String(item.product_id)));
        navigating=true;location.assign((window.Shopify?.routes?.root||'/')+(hasCanopy?'cart':'checkout'));return;
      }
      if(!await refresh())throw new Error(text.unavailable);
      const hasCanopy=cart?.items.some(item=>config.canopyProductIds.includes(String(item.product_id)));
      if(!hasCanopy){navigating=true;location.assign((window.Shopify?.routes?.root||'/')+'checkout');return;}
      if(!currentQuote)throw new Error(text.unavailable);
      if(!currentQuote.plan.units.some(unit=>unit.effective!=='none')){
        navigating=true;location.assign((window.Shopify?.routes?.root||'/')+'checkout');return;
      }
      const result=await api('/checkout',{cart:request,token:currentQuote.token});
      navigating=true;location.assign(result.checkoutUrl);
    }catch(error){setError(error.message||text.unavailable);}
    finally{if(!navigating){setBusy(false);button.removeAttribute('aria-busy');}}
  }
  document.addEventListener('change',async event=>{
    const input=event.target.closest?.('cart-items [data-cart-quantity]');
    if(input){
      event.preventDefault();event.stopImmediatePropagation();
      input.min=input.min||'0';input.step=input.step||'1';input.required=true;
      if(!pending&&input.reportValidity())void mutateCart({lineKey:input.dataset.line,quantity:Number(input.value)});
      return;
    }
    const select=event.target.closest?.('[data-ih-care-unit]');if(!select||pending)return;
    setBusy(true);
    selections[select.dataset.ihCareUnit]=select.value;
    try{await persist();await refresh();}catch(error){setError(error.message);}finally{setBusy(false);}
  },true);
  document.addEventListener('keydown',event=>{
    const control=event.target.closest?.('cart-items .btn-quantity[role="button"]');
    if(control&&event.key===' '){event.preventDefault();event.stopImmediatePropagation();if(!event.repeat)control.click();}
  },true);
  document.addEventListener('click',event=>{
    const quantityButton=event.target.closest?.('cart-items [data-plus-quantity-cart],cart-items [data-minus-quantity-cart]');
    const nativeRemove=event.target.closest?.('cart-items .cart-remove[data-line]');
    if(quantityButton||nativeRemove){
      event.preventDefault();event.stopImmediatePropagation();
      if(pending)return;
      const input=quantityButton?.closest('cart-update-quantity')?.querySelector('[data-cart-quantity]');
      if(nativeRemove){void mutateCart({lineKey:nativeRemove.dataset.line,quantity:0});return;}
      if(!input)return;
      input.min=input.min||'0';input.step=input.step||'1';input.required=true;
      if(!input.reportValidity())return;
      const quantity=Math.max(0,Number(input.value)+(quantityButton.hasAttribute('data-plus-quantity-cart')?1:-1));
      if(input.max&&quantity>Number(input.max)){input.reportValidity();return;}
      void mutateCart({lineKey:input.dataset.line,quantity});return;
    }
    const couponButton=event.target.closest?.('[data-ih-care-coupon-apply],[data-ih-care-coupon-clear]');
    if(couponButton){
      event.preventDefault();
      if(pending)return;
      const root=couponButton.closest('[data-ih-care-root]');
      const discount=couponButton.hasAttribute('data-ih-care-coupon-clear')?'':root.querySelector('[data-ih-care-coupon]').value.trim();
      void mutateCart({discount});
      return;
    }
    const remove=event.target.closest?.('[data-ih-care-remove]');
    if(remove){
      event.preventDefault();
      void mutateCart({unitKey:remove.dataset.ihCareRemove});
      return;
    }
    const button=event.target.closest?.('#cart-checkout,#cart-sidebar-checkout');
    if(!button)return;
    event.preventDefault();event.stopImmediatePropagation();
    void checkout(button,button.id==='cart-sidebar-checkout');
  },true);
  window.fetch=async(...args)=>{
    const response=await baseFetch(...args);
    const url=typeof args[0]==='string'?args[0]:args[0]?.url||'';
    if(/\/cart\/(add|change|clear|update)\.js(?:\?|$)/.test(url))schedule();
    return response;
  };
  if(window.jQuery)window.jQuery(document).ajaxComplete((_event,_xhr,settings)=>{
    if(/\/cart\/(add|change|clear|update)\.js(?:\?|$)/.test(settings.url||''))schedule();
  });
  for(const name of ['cart-update','cart:updated','cart:refresh','shopify:section:load'])document.addEventListener(name,schedule);
  window.addEventListener('pageshow',()=>{if(navigating){navigating=false;setBusy(false);}schedule();});window.addEventListener('focus',schedule);
  window.IHCanopyCare={refresh:()=>refresh({loadSelections:true})};
  if(roots().length)void refresh({loadSelections:true});
})();
